window.school = {
    data: {
        id: null,
        name: null,
        short_name: null,
        is_university: null,
        is_open_credit: null,
        motto: null,
        address: null,
        timezone: null,
        sessions: [],
        branches: [],
        shifts: [],
        classes: [],
        sections: [],
        semesters: [],
        class_semesters: [],
        exams: [],
        subjects: [],
    },

    fetchData: function () {
        const data = this._fetchDataFromLocalStorage();

        if (data) {
            this._onSchoolDataFetched(data);

            let lastSavedTimestamp = window.localStorage.getItem('school_data_last_saved');
            if (!lastSavedTimestamp || moment.unix(lastSavedTimestamp).isBefore(moment().subtract(1, 'hour'))) {
                console.log("School data saved on local storage is stale. Refreshing from API.")
                this._fetchDataFromApi();
            }
        } else {
            this._fetchDataFromApi(data => this._onSchoolDataFetched(data));
        }
    },

    _fetchDataFromLocalStorage: function () {
        if (window.schoolDataNoCache) {
            return null;
        }

        try {
            const localStorage = window.localStorage;

            if (window.authId) {
                const savedAuthId = localStorage.getItem('auth_id');
                if (savedAuthId !== window.authId.toString()) {
                    localStorage.removeItem(this._schoolDataKey());

                    return null;
                }
            }

            const schoolData = localStorage.getItem(this._schoolDataKey());
            const schoolDataJson = JSON.parse(schoolData || '{}');

            if (!Object.hasOwn(schoolDataJson, 'class_semesters')) {  // Old storage format
                localStorage.removeItem(this._schoolDataKey());

                return null;
            }

            return schoolDataJson;
        } catch (e) {
            console.error("Error accessing local storage.", e);

            return null;
        }
    },

    _fetchDataFromApi: function (callback) {
        if (!schoolId) {
            return;
        }

        const $this = this;

        $.get(
            `${appUrl}/schools/${schoolId}/data`,
            function (data, status) {
                if (status === 'success') {
                    if (!window.schoolDataNoCache) {
                        try {
                            const localStorage = window.localStorage;
                            localStorage.setItem($this._schoolDataKey(), JSON.stringify(data));
                            localStorage.setItem('school_data_last_saved', moment().unix().toString());
                            localStorage.setItem('auth_id', window.authId.toString());
                        } catch (e) {
                            if (!e.message.includes('exceeded the quota')) {
                                console.error("Error accessing local storage.", e);
                            }
                        }
                    }

                    if (callback) {
                        callback(data);
                    }
                } else {
                    console.error(`Error fetching school data from API. status: ${status}`);
                }
            },
        );
    },

    _schoolDataKey: function () {
        return 'school_data';
    },

    _isInventoryModule: function() {
        return window.location.href.includes('/inventory');
    },

    _onSchoolDataFetched: function (data) {
        this.data = data;
        this._setChangeHandlersToAppropriateFields();
        this._populateAllChangeableFields();
        if (typeof onSchoolDataLoaded === 'function') {
            onSchoolDataLoaded();
        }
        if (window.dataTable) {
            dataTable.ajax.reload();
        }
    },

    _populateAllChangeableFields: function () {
        /*
            Note, the select elements must be populated in reverse order (i.e. Groups -> Sections -> Classes etc.)
            so that a pre-populated higher-level select element can trigger change event and populate the dependent
            select element correctly. For example, if Class has pre-selected options (using "selected-val" attribute),
            then populating Class will trigger updating of Section and if Section is not yet populated, then it won't
            get the right options populated against the selected value of Class. Having Section populated before Class
            will ensure the correct values get populated in Section.
         */
        if (this.data.is_university) {
            this._populateBatches();
            this._populateStreams();
            this._populatePrograms();
            this._populateDepartments();
            this._populateFaculties();
            this._populateCampuses();
            this._populateSessions();
        } else {
            this._populateSessions();
            this._populateSubjects();
            this._populateExams();
            this._populateSemesters();
            this._populateElectiveSubjects();
            this._populateGroups();
            this._populateSections();
            this._populateClasses();
            this._populateShifts();
            this._populateBranches();
        }
    },

    _defaultElementId: function (elementId, fallback) {
        return elementId !== undefined ? elementId : fallback;
    },

    _normalizeArray: function (value) {
        if (Array.isArray(value)) return value;
        if (value !== undefined && value !== null && value !== "") return [value];
        return [];
    },

    _populateSessions: function () {
        this._populateItems('session', this._getSessions.bind(this));
    },

    _populateBranches: function (elementId) {
        elementId = this._defaultElementId(elementId, 'branch');

        this._populateItems(elementId, this._getBranches.bind(this));
    },

    _populateShifts: function (branchIds, elementId) {
        elementId = this._defaultElementId(elementId, 'shift');
        branchIds = this._normalizeArray(branchIds);

        this._populateItems(elementId, this._getShifts.bind(this), branchIds);
    },

    _populateClasses: function (branchIds, shiftIds, elementId) {
        elementId = this._defaultElementId(elementId, 'class');
        branchIds = this._normalizeArray(branchIds);
        shiftIds = this._normalizeArray(shiftIds);

        this._populateItems(elementId, this._getClasses.bind(this), branchIds, shiftIds);
    },

    _populateSections: function (sessionIds, branchIds, shiftIds, classIds, elementId) {
        elementId = this._defaultElementId(elementId, 'section');
        sessionIds = this._normalizeArray(sessionIds);
        branchIds = this._normalizeArray(branchIds);
        shiftIds = this._normalizeArray(shiftIds);
        classIds = this._normalizeArray(classIds);

        this._populateItems(elementId, this._getSections.bind(this), sessionIds, branchIds, shiftIds, classIds);
    },

    _populateGroups: function (branchIds, shiftIds, classIds, elementId) {
        elementId = this._defaultElementId(elementId, 'group_name');
        branchIds = this._normalizeArray(branchIds);
        shiftIds = this._normalizeArray(shiftIds);
        classIds = this._normalizeArray(classIds);

        this._populateItems(elementId, this._getGroups.bind(this), branchIds, shiftIds, classIds);
    },

    _populateElectiveSubjects: function (classIds, groupNames) {
        classIds = this._normalizeArray(classIds);
        groupNames = this._normalizeArray(groupNames);

        this._populateItems('third_subject', this._get3rdSubjects.bind(this), classIds, groupNames);
        this._populateItems('fourth_subject', this._get4thSubjects.bind(this), classIds, groupNames);
    },

    _populateSemesters: function (classIds, elementId) {
        elementId = this._defaultElementId(elementId, 'semester');
        classIds = this._normalizeArray(classIds);

        this._populateItems(elementId, this._getSemesters.bind(this), classIds);
    },

    _populateExams: function (classIds, semesterIds, subjectIds, elementId) {
        elementId = this._defaultElementId(elementId, 'exam');
        classIds = this._normalizeArray(classIds);
        semesterIds = this._normalizeArray(semesterIds);
        subjectIds = this._normalizeArray(subjectIds);

        this._populateItems(elementId, this._getExams.bind(this), classIds, semesterIds, subjectIds);
    },

    _populateSubjects: function (classIds, semesterIds, examIds, groupNames, elementId) {
        elementId = this._defaultElementId(elementId, 'subject');
        classIds = this._normalizeArray(classIds);
        semesterIds = this._normalizeArray(semesterIds);
        examIds = this._normalizeArray(examIds);
        groupNames = this._normalizeArray(groupNames);

        this._populateItems(elementId, this._getSubjects.bind(this), classIds, semesterIds, examIds, groupNames);
    },

    _populateCampuses: function (sessionIds, elementId) {
        elementId = this._defaultElementId(elementId, 'campus');
        sessionIds = this._normalizeArray(sessionIds);

        this._populateItems(elementId, this._getCampuses.bind(this), sessionIds);
    },

    _populateFaculties: function (sessionIds, campusIds, elementId) {
        elementId = this._defaultElementId(elementId, 'faculty');
        sessionIds = this._normalizeArray(sessionIds);
        campusIds = this._normalizeArray(campusIds);

        this._populateItems(elementId, this._getFaculties.bind(this), sessionIds, campusIds);
    },

    _populateDepartments: function (sessionIds, campusIds, facultyIds, elementId) {
        elementId = this._defaultElementId(elementId, 'department');
        sessionIds = this._normalizeArray(sessionIds);
        campusIds = this._normalizeArray(campusIds);
        facultyIds = this._normalizeArray(facultyIds);

        this._populateItems(elementId, this._getDepartments.bind(this), sessionIds, campusIds, facultyIds);
    },

    _populatePrograms: function (sessionIds, campusIds, facultyIds, departmentIds, elementId) {
        elementId = this._defaultElementId(elementId, 'program');
        sessionIds = this._normalizeArray(sessionIds);
        campusIds = this._normalizeArray(campusIds);
        facultyIds = this._normalizeArray(facultyIds);
        departmentIds = this._normalizeArray(departmentIds);

        this._populateItems(elementId, this._getPrograms.bind(this), sessionIds, campusIds, facultyIds, departmentIds);
    },

    _populateStreams: function (sessionIds, campusIds, facultyIds, departmentIds, programIds, elementId) {
        elementId = this._defaultElementId(elementId, 'stream');
        sessionIds = this._normalizeArray(sessionIds);
        campusIds = this._normalizeArray(campusIds);
        facultyIds = this._normalizeArray(facultyIds);
        departmentIds = this._normalizeArray(departmentIds);
        programIds = this._normalizeArray(programIds);

        this._populateItems(elementId, this._getStreams.bind(this), sessionIds, campusIds, facultyIds, departmentIds, programIds);
    },

    _populateBatches: function (campusIds, facultyIds, departmentIds, programIds, streamIds, elementId) {
        elementId = this._defaultElementId(elementId, 'batch');
        campusIds = this._normalizeArray(campusIds);
        facultyIds = this._normalizeArray(facultyIds);
        departmentIds = this._normalizeArray(departmentIds);
        programIds = this._normalizeArray(programIds);
        streamIds = this._normalizeArray(streamIds);

        this._populateItems(elementId, this._getBatches.bind(this), campusIds, facultyIds, departmentIds, programIds, streamIds);
    },

    _populateItems: function (selectElemId, itemOptionsFetchFunction, itemId1, itemId2, itemId3, itemId4) {
        itemId1 = Array.isArray(itemId1) ? itemId1 : (itemId1 ? [itemId1] : []);
        itemId2 = Array.isArray(itemId2) ? itemId2 : (itemId2 ? [itemId2] : []);
        itemId3 = Array.isArray(itemId3) ? itemId3 : (itemId3 ? [itemId3] : []);
        itemId4 = Array.isArray(itemId4) ? itemId4 : (itemId4 ? [itemId4] : []);
        // Instead of id selector, use attribute selector so that all elements with duplicate ids can be populated.
        // Id selector only returns first element with the id and ignores the duplicate ones.
        var selectElems = $('[id="' + selectElemId + '"]');
        if (selectElems.length) {
            selectElems.each(function (index, elem) {
                var selectElem = $(elem);
                // See if there's a default option or options with a "keep" attribute,
                // and if there are, preserve those for inserting later on.
                var keptOptions = selectElem.find('option[value=""],option[keep]');
                if (keptOptions.length) {
                    keptOptions = keptOptions.clone();
                }
                // Remove all options
                selectElem.find('option').remove();
                // Insert default/kept options if there were any
                if (keptOptions.length) {
                    selectElem.append(keptOptions);
                }
                var itemOptions = itemOptionsFetchFunction(itemId1, itemId2, itemId3, itemId4);
                // If selectElem has 'only' attribute set, keep only the items with the ids specified in 'only' attribute
                if (selectElem.attr('only') && selectElem.attr('only') !== '') {
                    const idsToKeep = selectElem.attr('only').split(',');
                    itemOptions = itemOptions.filter(option => idsToKeep.includes(option.id.toString()));
                }
                // Insert item options
                itemOptions.forEach(function (item) {
                    selectElem.append($('<option>', {
                        value: item.id,
                        text: item.name,
                        selected: (selectElem.attr('selected-val') && selectElem.attr('selected-val').split(',').includes(item.id.toString()))
                            || selectElem.attr('selected-name') === item.name.toString(),
                        disabled: selectElemId === 'section'
                            && window.location.href.replace(appUrl, '') === '/online-application/mmue'
                            && item.extras
                            && item.extras.hasOwnProperty('sectionSeatsAvailable')
                            && !item.extras.sectionSeatsAvailable
                    }));
                });
                // Hide element in case no option is available or only default option is available or only single option is available
                const onlyDefaultOptionAvailable = itemOptions.length === 1 && itemOptions[0].name === 'default';
                const onlySingleOptionAvailable = itemOptions.length === 1 || (itemOptions.length === 2 && itemOptions[0].value === '');
                const forceSelectedValue = selectElem.attr('force-selected-val');
                if (!itemOptions.length || onlyDefaultOptionAvailable || onlySingleOptionAvailable) {
                    if (!itemOptions.length || onlyDefaultOptionAvailable) {   // Select the default option and hide the input
                        selectElem.closest('.form-field-container').hide();
                        // Remove required attribute from the element so that Chrome doesn't get confused when trying to validate it
                        // See https://stackoverflow.com/questions/22148080/an-invalid-form-control-with-name-is-not-focusable
                        selectElem.removeAttr('required');
                        // Select default option if force-select-default-option attribute is specified
                        if (selectElem.attr('force-select-default-option')) {
                            selectElem.find('option').removeAttr('selected');
                            selectElem.find('option').filter((index, elem) => $(elem).text() === 'default').attr('selected', 'selected');
                        }
                    } else if (onlySingleOptionAvailable && forceSelectedValue === undefined) {    // Select the only available option
                        selectElem.find('option').removeAttr('selected');
                        selectElem.find('option').filter((index, elem) => itemOptions.length === 1 || $(elem).val() !== '').attr('selected', 'selected');
                    }
                } else {
                    selectElem.closest('.form-field-container').show();
                }
                // If an option is preselected, then trigger change event of the element so that dependent elements get
                // populated with the right options.
                if (selectElem.attr('selected-val') !== '' || selectElem.attr('selected-name') !== '') {
                    selectElem.change();
                }
                // If the element is rendered using selectpicker, refresh it
                if (selectElem.hasClass('selectpicker')) {
                    selectElem.selectpicker('refresh');
                }
            });
        }
    },

    _containsOrAll: function (haystack, needle) {
        return !haystack.length || haystack.includes(needle?.toString());
    },

    _sortByPosition: function (a, b) {
        if (!a) return 1;
        if (!b) return -1;

        return (a.extras?.position ?? a.position ?? 0) - (b.extras?.position ?? b.position ?? 0);
    },

    _getSessions: function () {
        return Object.values(this.data.sessions).sort((a, b) => a.position - b.position);
    },

    _getBranches: function () {
        return this._getItems(
            'branches',
            'id',
            (row) => this._isInventoryModule() ? true : !row.is_warehouse,
            'branches',
        ).sort(this._sortByPosition);
    },

    _getShifts: function (branchIds) {
        branchIds = this._normalizeArray(branchIds);

        return this._getItems(
            'sections',
            'shift_id',
            (row) => this._containsOrAll(branchIds, row.branch_id),
            'shifts',
        ).sort(this._sortByPosition);
    },

    _getClasses: function (branchIds, shiftIds) {
        branchIds = this._normalizeArray(branchIds);
        shiftIds = this._normalizeArray(shiftIds);

        return this._getItems(
            'sections',
            'class_id',
            (row) => {
                if (!this._containsOrAll(branchIds, row.branch_id)) return false;
                if (!this._containsOrAll(shiftIds, row.shift_id)) return false;
                return true;
            },
            'classes',
        ).sort(this._sortByPosition);
    },

    _getSections: function (sessionIds, branchIds, shiftIds, classIds) {
        return this._getItems(
            'sections',
            'id',
            (row) => {
                sessionIds = this._normalizeArray(sessionIds);
                branchIds = this._normalizeArray(branchIds);
                shiftIds = this._normalizeArray(shiftIds);
                classIds = this._normalizeArray(classIds);

                if (
                    sessionIds.length &&
                    row.academic_session_id !== null &&
                    !this._containsOrAll(sessionIds, row.academic_session_id)
                ) {
                    return false;
                }

                if (!this._containsOrAll(branchIds, row.branch_id)) return false;
                if (!this._containsOrAll(shiftIds, row.shift_id)) return false;
                if (!this._containsOrAll(classIds, row.class_id)) return false;

                return true;
            },
            'sections',
        ).sort(this._sortByPosition);
    },

    _getGroups: function (branchIds, shiftIds, classIds) {
        branchIds = this._normalizeArray(branchIds);
        shiftIds = this._normalizeArray(shiftIds);
        classIds = this._normalizeArray(classIds);

        const items = this._getItems(
            'sections',
            'class_id',
            (row) => {
                if (!this._containsOrAll(branchIds, row.branch_id)) return false;
                if (!this._containsOrAll(shiftIds, row.shift_id)) return false;
                if (!this._containsOrAll(classIds, row.class_id)) return false;

                if (!row.has_groups) {
                    return false;
                }

                return true;
            },
            'classes',
        );

        if (!items.length) {
            return [];
        }

        return [
            {id: 'science', name: window.___['science'] ?? 'Science'},
            {id: 'commerce', name: window.___['commerce'] ?? 'Business Studies'},
            {id: 'arts', name: window.___['arts'] ?? 'Humanities'}
        ];
    },

    _get3rdSubjects: function (classIds, groupNames) {
        classIds = this._normalizeArray(classIds);
        groupNames = this._normalizeArray(groupNames);

        return this._getItems(
            'subjects',
            'id',
            (row) => {
                if (!this._containsOrAll(classIds, row.class_id)) return false;
                if (!this._containsOrAll(groupNames, row.group)) return false;

                if (row.can_be_3rd !== 1) {
                    return false;
                }

                return true;
            },
            'subjects',
        ).sort(this._sortByPosition);
    },

    _get4thSubjects: function (classIds, groupNames) {
        classIds = this._normalizeArray(classIds);
        groupNames = this._normalizeArray(groupNames);

        return this._getItems(
            'subjects',
            'id',
            (row) => {
                if (!this._containsOrAll(classIds, row.class_id)) return false;
                if (groupNames.length && row.group && !groupNames.includes(row.group)) return false;

                if (row.can_be_4th !== 1) {
                    return false;
                }
                return true;
            },
            'subjects',
        ).sort(this._sortByPosition);
    },

    _getSemesters: function (classIds) {
        classIds = this._normalizeArray(classIds);

        return this._getItems(
            'class_semesters',
            'semester_id',
            (row) => this._containsOrAll(classIds, row.class_id),
            'semesters',
        ).sort(this._sortByPosition);
    },

    _getExams: function (classIds, semesterIds, subjectIds) {
        classIds = this._normalizeArray(classIds);
        semesterIds = this._normalizeArray(semesterIds);
        subjectIds = this._normalizeArray(subjectIds);

        const filteredSemesterIds = this._getItems(
            'class_semesters',
            'semester_id',
            (row) => {
                if (!this._containsOrAll(classIds, row.class_id)) return false;
                if (!this._containsOrAll(semesterIds, row.semester_id)) return false;

                return true;
            },
            'semesters',
        ).map(item => item.id.toString());

        return this._getItems(
            'exams',
            'id',
            (row) => {
                if (!this._containsOrAll(filteredSemesterIds, row.semester_id)) return false;
                if (!this._containsOrAll(subjectIds, row.subject_id)) return false;

                return true;
            },
            'exams',
        ).sort(this._sortByPosition);
    },

    _getSubjects: function (classIds, semesterIds, examIds, groupNames) {
        classIds = this._normalizeArray(classIds);
        semesterIds = this._normalizeArray(semesterIds);
        examIds = this._normalizeArray(examIds);
        groupNames = this._normalizeArray(groupNames);

        const filteredSemesterIds = examIds.length
            ? this._getItems(
                'exams',
                'semester_id',
                (row) => {
                    if (!this._containsOrAll(examIds, row.exam_id)) return false;
                    if (!this._containsOrAll(semesterIds, row.semester_id)) return false;

                    return true;
                },
                'semesters',
            ).map(item => item.id.toString())
            : semesterIds;

        const filteredClassIds = filteredSemesterIds.length
            ? this._getItems(
                'class_semesters',
                'class_id',
                (row) => {
                    if (!this._containsOrAll(classIds, row.class_id)) return false;
                    if (!this._containsOrAll(filteredSemesterIds, row.semester_id)) return false;

                    return true;
                },
                'classes',
            ).map(item => item.id.toString())
            : classIds;

        return this._getItems(
            'subjects',
            'id',
            (row) => {
                if (!this._containsOrAll(filteredClassIds, row.class_id)) return false;
                if (groupNames.length && row.group !== null && !groupNames.includes(row.group)) return false;

                return true;
            },
            'subjects',
        ).sort(this._sortByPosition);
    },

    _getCampuses: function (sessionIds) {
        sessionIds = this._normalizeArray(sessionIds);

        const campusIds = this._getItems(
            'student_enrollment_setup',
            'branch_id',
            (row) => this._containsOrAll(sessionIds, row.session_id),
            'branches',
        ).map(item => item.id.toString());

        return this._getItems(
            'branches',
            'id',
            'name',
            (row) => campusIds.includes(row.id),
            'branches',
        );
    },

    _getFaculties: function (sessionIds, campusIds) {
        sessionIds = this._normalizeArray(sessionIds);
        campusIds = this._normalizeArray(campusIds);

        const facultyIds = this._getItems(
            'student_enrollment_setup',
            'faculty_id',
            (row) => {
                if (!this._containsOrAll(sessionIds, row.session_id)) return false;
                if (!this._containsOrAll(campusIds, row.branch_id)) return false;

                return true;
            },
        ).map(item => item.id.toString());

        return this._getItems(
            'faculties',
            'id',
            (row) => facultyIds.includes(row.id),
            'faculties',
        );
    },

    _getDepartments: function (sessionIds, campusIds, facultyIds) {
        sessionIds = this._normalizeArray(sessionIds);
        campusIds = this._normalizeArray(campusIds);
        facultyIds = this._normalizeArray(facultyIds);

        const departmentIds = this._getItems(
            'student_enrollment_setup',
            'department_id',
            (row) => {
                if (!this._containsOrAll(sessionIds, row.session_id)) return false;
                if (!this._containsOrAll(campusIds, row.branch_id)) return false;
                if (!this._containsOrAll(facultyIds, row.faculty_id)) return false;

                return true;
            },
        ).map(item => item.id.toString());

        return this._getItems(
            'departments',
            'id',
            (row) => departmentIds.includes(row.id),
            'departments',
        );
    },

    _getPrograms: function (sessionIds, campusIds, facultyIds, departmentIds) {
        sessionIds = this._normalizeArray(sessionIds);
        campusIds = this._normalizeArray(campusIds);
        facultyIds = this._normalizeArray(facultyIds);
        departmentIds = this._normalizeArray(departmentIds);

        const programIds = this._getItems(
            'student_enrollment_setup',
            'program_id',
            (row) => {
                if (!this._containsOrAll(sessionIds, row.session_id)) return false;
                if (!this._containsOrAll(campusIds, row.branch_id)) return false;
                if (!this._containsOrAll(facultyIds, row.faculty_id)) return false;
                if (!this._containsOrAll(departmentIds, row.department_id)) return false;

                return true;
            },
        ).map(item => item.id.toString());

        return this._getItems(
            'programs',
            'id',
            (row) => programIds.includes(row.id),
            'programs',
        );
    },

    _getStreams: function (sessionIds, campusIds, facultyIds, departmentIds, programIds) {
        sessionIds = this._normalizeArray(sessionIds);
        campusIds = this._normalizeArray(campusIds);
        facultyIds = this._normalizeArray(facultyIds);
        departmentIds = this._normalizeArray(departmentIds);
        programIds = this._normalizeArray(programIds);

        const streamIds = this._getItems(
            'student_enrollment_setup',
            'stream_id',
            (row) => {
                if (!this._containsOrAll(sessionIds, row.session_id)) return false;
                if (!this._containsOrAll(campusIds, row.branch_id)) return false;
                if (!this._containsOrAll(facultyIds, row.faculty_id)) return false;
                if (!this._containsOrAll(departmentIds, row.department_id)) return false;
                if (!this._containsOrAll(programIds, row.program_id)) return false;

                return true;
            },
        ).map(item => item.id.toString());

        return this._getItems(
            'streams',
            'id',
            (row) => streamIds.includes(row.id),
            'streams',
        );
    },

    _getBatches: function (campusId, facultyIds, departmentIds, programIds, streamIds) {
        facultyIds = this._normalizeArray(facultyIds);
        departmentIds = this._normalizeArray(departmentIds);
        programIds = this._normalizeArray(programIds);
        streamIds = this._normalizeArray(streamIds);

        // TODO: filter using campusId first
        return this._getItems(
            'batches',
            'id',
            (row) => {
                if (!this._containsOrAll(facultyIds, row.faculty_id)) return false;
                if (!this._containsOrAll(departmentIds, row.department_id)) return false;
                if (!this._containsOrAll(programIds, row.program_id)) return false;
                if (!this._containsOrAll(streamIds, row.stream_id)) return false;
                return true;
            },
            'batches',
        );
    },

    _getItems: function (filteringDataset, itemIdAttribute, filter, detailsDataset) {
        const seen = new Set();
        const items = [];

        for (const row of Object.values(this.data[filteringDataset])) {
            if (!filter(row) || seen.has(row[itemIdAttribute])) {
                continue;
            }

            seen.add(row[itemIdAttribute]);

            const details = detailsDataset ? (this.data[detailsDataset][row[itemIdAttribute]] ?? null) : null;

            if (details === null) {
                // The item is inactive. Shouldn't be counted.
                continue;
            }

            items.push({ id: row[itemIdAttribute], name: details?.name, extras: details });
        }

        return items;
    },

    _setChangeHandlersToAppropriateFields: function () {
        const $this = this;
        if (this.data.is_university) {
            this._setChangeHandler('#session', function (event) {
                $this.onSessionChange(Number(event.target.value));
            });
            this._setChangeHandler('#campus', function (event) {
                $this.onCampusChange(Number($('#session').val()), Number(event.target.value));
            });
            this._setChangeHandler('#faculty', function (event) {
                $this.onFacultyChange(Number($('#session').val()), Number($('#campus').val()), Number(event.target.value));
            });
            this._setChangeHandler('#department', function (event) {
                $this.onDepartmentChange(Number($('#session').val()), Number($('#campus').val()), Number($('#faculty').val()), Number(event.target.value));
            });
            this._setChangeHandler('#program', function (event) {
                $this.onProgramChange(Number($('#session').val()), Number($('#campus').val()), Number($('#faculty').val()), Number($('#department').val()), Number(event.target.value));
            });
            this._setChangeHandler('#stream', function (event) {
                $this.onStreamChange(Number($('#session').val()), Number($('#campus').val()), Number($('#faculty').val()), Number($('#department').val()), Number($('#program').val()), Number(event.target.value));
            });
        } else {
            this._setChangeHandler('#session', function (event) {
                $this.onSessionChange($(event.target).val() || null);
            });
            this._setChangeHandler('#branch', function (event) {
                $this.onBranchChange($('#session').val(), $(event.target).val());
            });
            this._setChangeHandler('#shift', function (event) {
                $this.onShiftChange($('#session').val(), $('#branch').val(), $(event.target).val());
            });
            this._setChangeHandler('#class', function (event) {
                $this.onClassChange($('#session').val(), $('#branch').val(), $('#shift').val(), $(event.target).val());
            });
            this._setChangeHandler('#semester', function (event) {
                $this.onSemesterChange($('#class').val(), $(event.target).val(), event.target.hasAttribute('data-no-subject-change-trigger'));
            });
            this._setChangeHandler('#exam', function (event) {
                $this.onExamChange($('#class').val(), $('#semester').val(), $(event.target).val(), event.target.hasAttribute('data-no-subject-change-trigger'));
            });
            this._setChangeHandler('#group_name', function (event) {
                $this.onGroupChange($('#class').val(), $(event.target).val());
            });
        }
    },

    _setChangeHandler: function (fieldSelector, handler) {
        const elem = $(fieldSelector);
        if (elem.length) {
            elem.change(handler);
        }
    },

    onBranchChange: function (sessions, branches) {
        sessions = this._normalizeArray(sessions);
        branches = this._normalizeArray(branches);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateGroups(branches);
        this._populateSections(sessions, branches);
        this._populateClasses(branches);
        this._populateShifts(branches);
    },

    onShiftChange: function (sessions, branches, shifts) {
        sessions = this._normalizeArray(sessions);
        branches = this._normalizeArray(branches);
        shifts = this._normalizeArray(shifts);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateGroups(branches, shifts);
        this._populateSections(sessions, branches, shifts);
        this._populateClasses(branches, shifts);
    },

    onClassChange: function (sessions, branches, shifts, classes) {
        sessions = this._normalizeArray(sessions);
        branches = this._normalizeArray(branches);
        shifts = this._normalizeArray(shifts);
        classes = this._normalizeArray(classes);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateSubjects(classes);
        this._populateExams(classes);
        this._populateSemesters(classes);
        this._populateGroups(branches, shifts, classes);
        this._populateSections(sessions, branches, shifts, classes);
    },

    onGroupChange: function (classes, groupNames) {
        classes = this._normalizeArray(classes);
        groupNames = this._normalizeArray(groupNames);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateElectiveSubjects(classes, groupNames);
        this._populateSubjects(classes, null, null, groupNames);
    },

    onSemesterChange: function (classes, semesters, dontChangeSubjects) {
        classes = this._normalizeArray(classes);
        semesters = this._normalizeArray(semesters);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        if (!dontChangeSubjects) {
            this._populateSubjects(classes, semesters);
        }
        this._populateExams(classes, semesters);
    },

    onExamChange: function (classes, semesters, exams, dontChangeSubjects) {
        classes = this._normalizeArray(classes);
        semesters = this._normalizeArray(semesters);
        exams = this._normalizeArray(exams);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        if (!dontChangeSubjects) {
            this._populateSubjects(classes, semesters, exams);
        }
    },

    onSessionChange: function (sessions) {
        sessions = this._normalizeArray(sessions);

        if (!this.data.is_university) {
            // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
            this._populateSections();
        } else {
            // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
            this._populateBatches();
            this._populateStreams(sessions);
            this._populatePrograms(sessions);
            this._populateDepartments(sessions);
            this._populateFaculties(sessions);
            this._populateCampuses(sessions);
        }
    },

    onCampusChange: function (sessions, campuses) {
        sessions = this._normalizeArray(sessions);
        campuses = this._normalizeArray(campuses);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campuses);
        this._populateStreams(sessions, campuses);
        this._populatePrograms(sessions, campuses);
        this._populateDepartments(sessions, campuses);
        this._populateFaculties(sessions, campuses);
    },

    onFacultyChange: function (sessions, campuses, faculties) {
        sessions = this._normalizeArray(sessions);
        campuses = this._normalizeArray(campuses);
        faculties = this._normalizeArray(faculties);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campuses, faculties);
        this._populateStreams(sessions, campuses, faculties);
        this._populatePrograms(sessions, campuses, faculties);
        this._populateDepartments(sessions, campuses, faculties);
    },

    onDepartmentChange: function (sessions, campuses, faculties, departments) {
        sessions = this._normalizeArray(sessions);
        campuses = this._normalizeArray(campuses);
        faculties = this._normalizeArray(faculties);
        departments = this._normalizeArray(departments);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campuses, faculties, departments);
        this._populateStreams(sessions, campuses, faculties, departments);
        this._populatePrograms(sessions, campuses, faculties, departments);
    },

    onProgramChange: function (sessions, campuses, faculties, departments, programs) {
        sessions = this._normalizeArray(sessions);
        campuses = this._normalizeArray(campuses);
        faculties = this._normalizeArray(faculties);
        departments = this._normalizeArray(departments);
        programs = this._normalizeArray(programs);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campuses, faculties, departments, programs);
        this._populateStreams(sessions, campuses, faculties, departments, programs);
    },

    onStreamChange: function (sessions, campuses, faculties, departments, programs, streams) {
        sessions = this._normalizeArray(sessions);
        campuses = this._normalizeArray(campuses);
        faculties = this._normalizeArray(faculties);
        departments = this._normalizeArray(departments);
        programs = this._normalizeArray(programs);
        streams = this._normalizeArray(streams);

        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campuses, faculties, departments, programs, streams);
    },

    getSubjects: function (clazz, groupName) {
        return this._getSubjects(clazz, null, null, groupName);
    }
};

window.confirmDeletion = function (route, title, onSuccess) {
    Swal.fire(
        {
            title: title || "Delete record?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f2353c",
            confirmButtonText: "Yes, delete it!",
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return fetch(
                    route,
                    {
                        method: 'delete',
                        headers: new Headers({'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}),
                        credentials: 'include'  // adds cookie header
                    }
                ).then(async function (response) {
                    if (response.status === 422) {  // Validation error
                        const responseJson = await response.json();
                        throw new Error(responseJson.message || responseJson);
                    }

                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                }).catch(function (error) {
                    Swal.showValidationMessage('Failed to delete. ' + error);
                });
            }
        }
    ).then(function (result) {
        if (result.value) {
            Swal.fire('Deleted!', '', 'success');
            if (onSuccess) {
                onSuccess();
            }
            if (window.dataTable || typeof dataTable !== 'undefined') {
                dataTable.ajax.reload(null, false);
            }
        }
    });
};

window.editDeleteButtonsView = function (id, editRoute, deleteRoute) {
    return '<div class="actions text-nowrap">\n' +
      (editRoute !== null && editRoute !== '' ?
        '       <a href="'+ editRoute.replace('/0', '/' + id) +'" target="_blank"' +
        '          class="btn btn-icon btn-pure btn-default mr-10"' +
        '          data-toggle="tooltip"\n' +
        '          data-original-title="Edit">\n' +
        '           <i class="fa fa-edit"></i>\n' +
        '       </a>\n'
        : '') +
      (deleteRoute !== null && deleteRoute !== '' ?
        '       <a href="javascript:void(0)" ' +
        '          onclick=\'confirmDeletion( "' + deleteRoute.replace('/0', '/' + id) +'")\'' +
        '          class="btn btn-icon btn-pure btn-danger"' +
        '          data-toggle="tooltip"\n' +
        '          data-original-title="Delete">\n' +
        '           <i class="fa fa-times"></i>\n' +
        '       </a>\n'
       : '') +
        '   </div>';
};

/**
 * Disable mouse wheel on a input number field when in focus (to prevent Chromium browsers change the value when scrolling).
 * https://stackoverflow.com/questions/9712295/disable-scrolling-on-input-type-number#answer-20838527
 */
window.disableMouseWheelOnNumberInputs = function () {
    $('input[type=number]').focus(function () {
        $(this).on('mousewheel.disableScroll', function (e) {
            e.preventDefault()
        });
    }).blur(function () {
        $(this).off('mousewheel.disableScroll')
    });
};

/**
 * Wire branch-select change handlers that repopulate employee-shift dropdowns with the shifts of the selected branch.
 *
 * @param shiftsWithBranch list of {id, name, branch_id} as returned by the EmployeeShiftsWithBranch action (empty when branch-wise shifts are disabled)
 * @param selectedVal
 * @param pairs optional list of {branchSelector, shiftSelector, keepOptions, refreshSelectpicker}; defaults to '#branch' -> '#employee_shift'
 */
window.initBranchWiseEmployeeShifts = function (shiftsWithBranch,
                                                selectedVal,
                                                pairs = [{branchSelector: '#branch', shiftSelector: '#employee_shift'}]) {
    if (!shiftsWithBranch.length) {
        return;
    }

    pairs.forEach(function (pair) {
        $(pair.branchSelector).on('change', function () {
            const employeeShiftElem = $(pair.shiftSelector);
            employeeShiftElem.find(`option:gt(${(pair.keepOptions ?? 1) - 1})`).remove();

            shiftsWithBranch.forEach(shift => {
                if (shift.branch_id === Number($(this).val()) || !$(this).val()) {
                    employeeShiftElem.append(`<option value="${shift.id}" ${shift.id == selectedVal ? 'selected' : ''}>${shift.name}</option>`);
                }
            })

            if (pair.refreshSelectpicker) {
                employeeShiftElem.selectpicker('refresh');
            }
        });
    });
};

window.getReportFiltersHtml = function (reportFilters) {
    if (reportFilters) {
        var filtersTable = $('<table><tr></tr></table>');
        for (var i = 0; i < reportFilters.length; i++) {
            var filter = reportFilters[i];
            if (!filter.value) {
                continue;
            }
            filtersTable.append(
                '<td class="px-10">' +
                '   <span class="font-weight-600">' + filter.key + ':</span>' +
                '   <span class="pl-5">' + filter.value + '</span>' +
                '</td>'
            );
        }

        return filtersTable.html();
    }

    return '';
};

window.getReportFiltersText = function (reportFilters) {
    if (reportFilters) {
        let filterTexts = [];
        for (let i = 0; i < reportFilters.length; i++) {
            const filter = reportFilters[i];
            if (!filter.value) {
                continue;
            }
            filterTexts.push(`${filter.key}: ${filter.value}`);
        }

        return filterTexts.join('   •   ');
    }

    return '';
};

/**
 * https://stackoverflow.com/questions/4649604/jquery-select-next-text-field-on-enter-key-press#answer-10543216
 * @param inputClassName The class name of all the text fields in the group where this function should apply
 */
window.goToNextInputOnEnter = function (inputClassName) {
    $(`.${inputClassName}`).keypress(function (event) {
        if (event.keyCode === 13) {
            var textboxes = $(`input.${inputClassName}`);
            var currentBoxNumber = textboxes.index(this);
            if (textboxes[currentBoxNumber + 1] != null) {
                var nextBox = textboxes[currentBoxNumber + 1];
                nextBox.focus();
                nextBox.select();
                event.preventDefault();

                return false;
            }
        }
    });
};

/**
 * @param inputClassName The class name of all the text fields in the group where this function should apply
 */
window.goToNextRowSameColumnInputOnEnter = function (inputClassName) {
    $(`.${inputClassName}`).keypress(function (event) {
        if (event.keyCode === 13) {
            const sourceTd = $(event.target).closest('td');
            const sourceTr = $(event.target).closest('tr');
            const sourceTdIndex = sourceTr.find('td').index(sourceTd);
            const sourceTrIndex = sourceTr.parent().find('tr').index(sourceTr);

            const nextBox = sourceTr.parent().find('tr').eq(sourceTrIndex + 1)
                .find('td').eq(sourceTdIndex).find(`.${inputClassName}`);

            if (nextBox.length) {
                nextBox.focus();
                nextBox.select();
                event.preventDefault();

                return false;
            }
        }
    });
};

// Highlight corresponding menu item when page renders
window.highlightMenuItem = function (menuPath) {
    _highlightMenuItemRecursive(menuPath.split(' '));
};
function _highlightMenuItemRecursive(pathSegments) {
    if (pathSegments.length === 0) {
        return;
    }

    $('.site-menu >' + pathSegments.join(' ')).addClass('active open');

    pathSegments.splice(pathSegments.length - 1, 1);
    _highlightMenuItemRecursive(pathSegments);
}

window.nl2br = function(str) {
    return str ? str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1 <br /> $2') : '';
};

window.dataTableCellRenderCheckMarkOrEmpty = function(data, type, row, meta, addColor) {
    if (!data) {
        return '';
    }

    if (type === 'pdf' || type === 'csv') {
        return 'Yes';
    }

    return  addColor ? '<span class="text-success">✔</span>' : '✔';
}

window.dataTableCellRenderCheckMarkOrCross = function(data, type, row, meta, addColor) {
    if (type === 'pdf' || type === 'csv') {
        return data ? 'Yes' : 'No';
    }

    if (addColor) {
        return data ? '<span class="text-success">✔</span>' : '<span class="text-danger">✘</span>';
    }

    return data ? '✔' : '✘';
}

// System Setup Edit Pages - Start

window.renderTextInputColumn = function(type, inputName, value, cssClass, isRequired, errors, meta, includeIdRow, idValue){
    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <input class="form-control mx-auto ${cssClass ?? ''} ${error ? 'is-invalid' : ''}"
                       type="${type}" name="${inputName}[${meta.row}]" value="${value ?? ''}"
                       ${isRequired ? 'required' : ''} />
                <small class="invalid-feedback">${error}</small>
            </div>
        </div>
    `;
}

window.renderDateInputColumn = function(inputName, value, cssClass, isRequired, errors, meta, placeholder, dateFormat, includeIdRow, idValue){
    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <div class="input-group" style="flex-wrap: nowrap">
                    <input class="form-control mx-auto ${cssClass ?? ''} ${error ? 'is-invalid' : ''}"
                           type="text" name="${inputName}[${meta.row}]" value="${value ?? ''}"
                           id="${inputName}-${meta.row}" ${isRequired ? 'required' : ''}
                           placeholder="${placeholder ?? 'DD-MM-YYYY'}"
                           data-plugin="datepicker"
                           data-date-format="${dateFormat ?? 'dd-mm-yyyy'}"
                           data-orientation="bottom"
                           data-autoclose="true"
                           data-today-highlight="true"
                           autocomplete="off"
                    />
                    <div class="input-group-append" onclick="$('#${inputName}-${meta.row}').focus()">
                         <span class="input-group-text">
                             <i class="icon wb-calendar" aria-hidden="true"></i>
                         </span>
                    </div>
                </div>
                <small class="invalid-feedback">${error}</small>
            </div>
        </div>
    `;
}

window.renderTextAreaInputColumn = function(type, inputName, value, cssClass, isRequired, errors, meta, includeIdRow, idValue){
    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <textarea class="form-control mx-auto ${cssClass ?? ''} ${error ? 'is-invalid' : ''}"
                       type="${type}" name="${inputName}[${meta.row}]"
                       ${isRequired ? 'required' : ''}>${value ?? ''}</textarea>
                <small class="invalid-feedback">${error}</small>
            </div>
        </div>
    `;
}

window.renderSelectInputColumn = function(items, inputName, value, cssClass, isRequired, errors, meta, includeIdRow, idValue, searchable) {
    let options = '';
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        options += `
            <option value="${item.value}" ${value == item.value ? 'selected="selected"' : ''}>
                ${item.label}
            </option>
        `;
    }

    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <select class="form-control mx-auto ${cssClass ?? ''} ${error ? 'is-invalid' : ''} ${searchable ? 'selectpicker' : ''}"
                        name="${inputName}[${meta.row}]" ${isRequired ? 'required' : ''}
                        ${searchable ? 'data-live-search="true"' : ''}>
                    ${options}
                </select>
                <small class="invalid-feedback">${error}</small>
            </>
        </div>
    `;
}

window.renderCheckboxColumn = function(inputName, value, cssClass, isRequired, errors, meta, includeIdRow, idValue){
    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <div class="mt-2 abc-checkbox abc-checkbox-circle abc-checkbox-success ${cssClass ?? ''}">
                    <input name="${inputName}[${meta.row}]" id="${inputName}-${meta.row}"
                           type="checkbox" ${value ? 'checked' : ''}/>
                    <label for="${inputName}-${meta.row}" class="pl-20 pt-10"></label>
                </div>
                <small class="invalid-feedback">${error}</small>
            </div>
        </div>
    `;
}

window._renderHiddenIdInput = function(includeIdRow, idValue, meta) {
    return includeIdRow === true
        ? `<input type="hidden" name="id[${meta.row}]" value="${idValue ?? ''}"/>`
        : '';
}

window._getError = function(inputName, meta, errors) {
    const errorField = `${inputName}.${meta.row}`;

    return errors.hasOwnProperty(errorField) ? errors[errorField][0] : '';
}

// System Setup Edit Pages - End

// Common initialization point
$(function () {
    disableMouseWheelOnNumberInputs();
});
